import { useDataChange, useDataValue } from 'Simple/Data'

export function useOnChange(props) {
  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })

  let employees = useDataValue({
    context: 'employees',
    viewPath: props.viewPath,
  })

  let selected_employees = useDataValue({
    context: 'selected',
    path: 'employees',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    change(next => {
      next.employee_ids = value
      // bit convoluted, but this is because they can untick
      // from the drop down and remove from the tags list
      // this keeps them in sync
      next.employees = [
        ...new Map(
          [
            ...selected_employees.filter(
              employee =>
                !employees.some(person => person.id === employee.id) ||
                value?.includes(employee.id)
            ),
            ...employees.filter(person => value.includes(person.id)),
          ].map(person => [person.id, person])
        ).values(),
      ]
    })
  }
}

export function filterExisting(all, selected) {
  return all.filter(person => !selected?.includes(person.id))
}

export function getList(searched, all) {
  return searched.length ? searched : all
}

export function useOnClick(props) {
  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })

  let employees = useDataValue({
    context: 'selected',
    path: 'employees',
    viewPath: props.viewPath,
  })

  let employee_ids = useDataValue({
    context: 'selected',
    path: 'employee_ids',
    viewPath: props.viewPath,
  })

  return function onClick(value) {
    change(next => {
      next.employee_ids = employee_ids.filter(id => id !== value)
      next.employees = employees.filter(employee => employee.id !== value)
    })
  }
}

export function hasListItems(value) {
  return Array.isArray(value) && value.length > 0
}
